import { DeviceOSType } from '@/api/user-portal-api-generated';
import {
  getMobileAppDeepLinkScheme,
  isValidEnvValue,
} from '@/config/env-config';

const DEEP_LINK_SCHEME_PLACEHOLDER = '__MOBILE_APP_DEEP_LINK_SCHEME__';
const DEEP_LINK_SCHEME_FALLBACK = 'newcoreauth-dev';
const ONBOARDING_DEEP_LINK_PATH = 'onboarding-entry';
const PAIRING_DEEP_LINK_PATH = 'token-entry';

export function getDeepLinkScheme() {
  const runtimeScheme = getMobileAppDeepLinkScheme();

  if (isValidEnvValue(runtimeScheme, DEEP_LINK_SCHEME_PLACEHOLDER)) {
    return runtimeScheme;
  }

  return DEEP_LINK_SCHEME_FALLBACK;
}

export function getMobilePlatform() {
  if (typeof navigator === 'undefined') {
    return null;
  }

  const userAgent = navigator.userAgent ?? '';

  if (/android/i.test(userAgent)) {
    return DeviceOSType.ANDROID;
  }

  if (/iphone|ipod/i.test(userAgent)) {
    return DeviceOSType.IOS;
  }

  return null;
}

export function createOnboardingDeepLinkUrl(token: string) {
  return `${getDeepLinkScheme()}://${ONBOARDING_DEEP_LINK_PATH}?token=${encodeURIComponent(token)}`;
}

export function createPairingDeepLinkUrl(pairingCode?: string) {
  const query = pairingCode
    ? `?pairingCode=${encodeURIComponent(pairingCode)}`
    : '';

  return `${getDeepLinkScheme()}://${PAIRING_DEEP_LINK_PATH}${query}`;
}

/**
 * Fire-and-forget deep link navigation. We don't observe whether the OS
 * actually handed control to the installed app — the install UI stays visible
 * regardless, so a visibility/timeout heuristic would be unused noise.
 */
export function attemptAppLaunch(deepLinkUrl: string) {
  try {
    window.location.href = deepLinkUrl;
  } catch {
    // Browser refused the navigation (e.g. blocked scheme); install UI is already shown.
  }
}
